<template>
  <div v-if="!$route.params.id || badge">
    <h1>
      <template v-if="badge">
        <router-link :to="{name: 'badges'}">Badges</router-link>
        &nbsp;>&nbsp;
        <router-link :to="{name: 'badge', params: {id: badge.id}}">{{badge.identifier}}</router-link>
        &nbsp;>&nbsp;Modifier
      </template>
      <template v-else>
        Ajouter un badges
      </template>
    </h1>
    <form class="mf-container" @submit.prevent="submit">
      <div class="flex mb-4 items-center">
        <div class="flex-grow text-gray-700">
          <template v-if="badge">
            Les informations des badges ne peuvent pas être modifiés.
          </template>
          <template v-else>
            Remplissez le formulaire ci-dessous puis cliquez sur ajouter.
          </template>
        </div>
        <div class="flex-shrink-0">
          <button
            v-if="badge"
            type="button"
            tag="button"
            @click="removeBadge"
            class="mf-destructive-button mr-2">
            Supprimer
          </button>
          <button
            v-if="badge"
            type="button"
            tag="button"
            @click="toggleIsLost"
            class="mf-destructive-button mr-12">
            Perdu / Usé
          </button>
          <button
            type="button"
            tag="button"
            @click="$router.go(-1)"
            class="mf-secondary-button mr-2">
            Annuler
          </button>
          <button class="mf-primary-button">
            <template v-if="badge">
              {{isLoading ? 'Modification en cours…' : 'Modifier' }}
            </template>
            <template v-else>
              {{isLoading ? 'Ajout en cours…' : 'Ajouter' }}
            </template>
          </button>
        </div>
      </div>
      <div>
        <div class="flex flex-wrap -mx-3">
          <div class="w-full md:w-1/4 px-3 mb-6 md:mb-0">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="last-name">
              Numéro
            </label>
            <input
              ref="identifier"
              v-model="badgeModel.identifier"
              class="appearance-none block w-full  text-gray-700 border rounded py-3 mb-3 leading-tight focus:outline-none"
              :class="badge ? 'bg-white border-white' : 'px-4 bg-gray-200 border-gray-200 focus:bg-white focus:border-gray-500'"
              type="text"
              placeholder="1234"
              autocomplete="no"
              :readonly="badge">
          </div>
          <div class="w-full md:w-1/4 px-3">
            <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="subscription">
              Site
            </label>
            <div class="relative">
              <select
                v-model="badgeModel.site"
                class="block appearance-none w-full border text-gray-700 py-3 pr-8 rounded leading-tight focus:outline-none"
                :class="badge ? 'bg-white border-white -ml-1' : 'px-4 bg-gray-200 border-gray-200 focus:bg-white focus:border-gray-500'"
                :disabled="badge">
                <option>Harnes</option>
                <option>Lille</option>
                <option>Vitrolles</option>
              </select>
              <div v-if="!badge" class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { validateInputs } from '../utils/operations'

export default {
  data() {
    return {
      isLoading: false,
      badge: null,
      badgeModel: {
        identifier: null,
        site: 'Harnes'
      }
    }
  },
  methods: {
    async submit() {
      if (validateInputs(this.badgeModel.identifier, this.badgeModel.site)) {
        this.isLoading = true
        const badge = await this.$store.dispatch(this.badge ? 'badges/updateBadge' : 'badges/createBadge', this.badgeModel)
        this.isLoading = false
        this.$router.push({ name: this.badge ? 'badge' : 'badges', params: { badgeId: badge.id, id: badge.id } })
      }
      else {
        alert('Veuillez remplir tous les éléments du formulaire.')
      }
    },
    async removeBadge() {
      if (window.confirm('La suppression du badge le fera disparaître de la liste.\nIl apparaîtra toujours dans l’historique des mouvements.\n\nSouhaitez-vous continuer ?')) {
        await this.$store.dispatch('badges/removeBadge', this.badgeModel)
        alert('La suppression a bien été effectuée !')
        this.$router.push({ name: 'badges' })
      }
    },
    async toggleIsLost() {
      const lostLabel = this.badge.isLost ? 'apparaître' : 'disparaître'
      if (window.confirm(`Cette déclaration fera ${lostLabel} l’article de la liste des articles distribuables.\n\nSouhaitez-vous continuer ?`)) {
        const badgeModel = { ...this.badge, isLost: !this.badge.isLost }
        const badge = await this.$store.dispatch('badges/updateBadge', badgeModel)
        alert('La déclaration a bien été prise en compte !')
        this.$router.push({ name: 'badge', params: { id: badge.id } })
      }
    }
  },
  mounted() {
    if (this.$refs.identifier) {
      this.$refs.identifier.focus()
    }
  },
  async created() {
    const { id } = this.$route.params
    if (id) {
      try {
        this.badge = await this.$store.dispatch('badges/getBadge', id)
        this.badgeModel = { ...this.badge }
      }
      catch (e) {
        this.$router.push({ name: 'badges' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
